import type { FC } from 'react';

import { InputPhone } from 'components/input/InputPhone';
import { InputTitle } from 'components/input/InputTitle';
import { Radio, Row, Spacing, TextInput, Typography } from 'enable-ui';
import { GenderType } from 'enums/gender';

import type { AdminFormProps } from '../core/type';

const textInputStyles = {
  containerStyle: { maxWidth: 'auto' },
  inputStyle: { borderRadius: 12 },
};

export const AdminForm: FC<AdminFormProps> = ({
  gender,
  phone,
  isView,
  handleChangePhone,
  handleChange,
  onChangeGender,
  firstName,
  lastName,
}) => {
  return (
    <Spacing
      spacing="md"
      type="margin"
      placement="top"
      style={{
        width: '100%',
      }}
    >
      <Row direction="column">
        <Typography variant="h4" weight={600}>
          Profile
        </Typography>
        <Row
          style={{
            gap: 12,
            marginTop: 16,
          }}
        >
          <div style={{ width: '50%' }}>
            <Row direction="column">
              <InputTitle title="Given name" required />
              <TextInput
                name="firstName"
                {...textInputStyles}
                value={firstName}
                onChange={handleChange}
                maxLength={80}
              />
            </Row>
          </div>
          <div style={{ width: '50%' }}>
            <Row direction="column">
              <InputTitle title="Family name" />
              <TextInput
                name="lastName"
                {...textInputStyles}
                value={lastName}
                onChange={handleChange}
                maxLength={80}
              />
            </Row>
          </div>
        </Row>
        <Spacing
          spacing="sm"
          placement="top"
          type="margin"
          style={{
            width: '100%',
          }}
        >
          <InputTitle title="Gender (optional)" />
          <Row>
            {Object.keys(GenderType).map((key) => {
              const checked = gender?.toLowerCase() === key.toLowerCase();

              return (
                <Radio
                  disabled={isView}
                  key={key}
                  checked={checked}
                  onClick={onChangeGender(key)}
                  style={{
                    marginRight: 10,
                  }}
                >
                  {key}
                </Radio>
              );
            })}
          </Row>
        </Spacing>
        <Spacing
          spacing="sm"
          placement="top"
          type="margin"
          style={{
            width: '100%',
          }}
        >
          <InputPhone
            disabled={isView}
            title="Phone number (optional)"
            value={phone}
            onChange={handleChangePhone}
          />
        </Spacing>
      </Row>
    </Spacing>
  );
};
